import React, { useState } from 'react';
import './Experience.css';

const Experience = () => {
  const [activeTab, setActiveTab] = useState('teaching');

  const teachingExperience = [
    {
      id: 1,
      position: "Assistant Professor",
      institution: "School of Management, Pimpri Chinchwad University",
      period: "July 2023 - Present",
      location: "Pune, Maharashtra",
      highlights: [
        "Teaching Accounting and Financial Management courses",
        "Mentoring graduate students in research projects",
        "Contributing to curriculum development"
      ]
    },
    {
      id: 2,
      position: "Associate Professor",
      institution: "GNIOT, Greater Noida",
      period: "Oct 2022 - June 2023",
      location: "Greater Noida, Uttar Pradesh",
      highlights: [
        "Directed admission team as head of MBA department",
        "Faculty resource mobilization (more than 60%)",
        "Enhanced academic curriculum and student engagement"
      ]
    },
    {
      id: 3,
      position: "Associate Professor",
      institution: "MKM College Of Management For Girls, Hodal, Palwal",
      period: "Sep 2019 - Sep 2022",
      location: "Hodal, Palwal",
      highlights: [
        "Led admission team as department head",
        "Organized academic and industry interaction programs",
        "Mentored female students in management education"
      ]
    },
    {
      id: 4,
      position: "Assistant Professor",
      institution: "Lord Krishna College of Management, Ghaziabad",
      period: "Sep 2011 - May 2019",
      location: "Ghaziabad, Uttar Pradesh",
      highlights: [
        "Directed admission team as head for 7 years",
        "Organized national seminars and academic events",
        "Supervised student research projects and internships"
      ]
    },
    {
      id: 5,
      position: "Assistant Professor",
      institution: "Taksila Business School, Greater Noida",
      period: "Oct 2010 - Sep 2011",
      location: "Greater Noida, Uttar Pradesh",
      highlights: [
        "Taught financial management courses",
        "Developed industry-academia interface programs"
      ]
    },
    {
      id: 6,
      position: "Assistant Professor",
      institution: "Radha Govind Engineering College, Meerut",
      period: "Aug 2009 - Sep 2010",
      location: "Meerut, Uttar Pradesh",
      highlights: [
        "Taught management subjects to engineering students",
        "Integrated technical and management education"
      ]
    },
    {
      id: 7,
      position: "Assistant Professor",
      institution: "Multanimal Modi P.G. College, Modi Nagar",
      period: "July 2006 - June 2009",
      location: "Modi Nagar, Uttar Pradesh",
      highlights: [
        "Began academic career in post-graduate college",
        "Developed foundational teaching methodologies"
      ]
    }
  ];

  const administrativeExperience = [
    {
      id: 1,
      role: "Admission Team Head",
      institution: "GNIOT, Greater Noida",
      period: "Oct 2022 - Current",
      responsibilities: [
        "Leading MBA department admission processes",
        "Developing admission strategies and policies",
        "Coordinating with marketing and outreach teams"
      ]
    },
    {
      id: 2,
      role: "Admission Team Head",
      institution: "MKM College of Management For Girls, Hodal, Palwal",
      period: "Feb 2021 - Sep 2022",
      responsibilities: [
        "Managed complete admission lifecycle",
        "Implemented student recruitment strategies",
        "Enhanced institutional visibility and reach"
      ]
    },
    {
      id: 3,
      role: "Admission Team Head",
      institution: "Lord Krishna College of Management, Ghaziabad",
      period: "Sep 2011 - Aug 2018",
      responsibilities: [
        "Directed admission operations for 7 years",
        "Achieved consistent enrollment targets",
        "Built strong industry-institute relationships"
      ]
    },
    {
      id: 4,
      role: "University Observer",
      institution: "AKTU Lucknow, TMU Moradabad",
      period: "Various Periods",
      responsibilities: [
        "Served as official observer for university examinations",
        "Ensured fair and transparent examination processes",
        "Maintained academic integrity standards"
      ]
    },
    {
      id: 5,
      role: "Head of Flying Squad",
      institution: "AKTU Examinations",
      period: "Various Periods",
      responsibilities: [
        "Led inspection teams for examination centers",
        "Ensured compliance with university regulations",
        "Addressed examination-related issues"
      ]
    },
    {
      id: 6,
      role: "Paper Moderator",
      institution: "TMU, Moradabad",
      period: "Various Periods",
      responsibilities: [
        "Moderated question papers for university examinations",
        "Ensured quality and relevance of examination content",
        "Maintained academic standards and fairness"
      ]
    }
  ];

  return (
    <section className="experience" id="experience">
      <div className="experience-container">
        {/* Section Header */}
        <div className="section-header">
          <h2 className="section-title">Professional Experience</h2>
          <p className="section-subtitle">
            16+ Years of Academic Excellence & Leadership
          </p>
          <div className="section-divider"></div>
        </div>

        {/* Experience Tabs */}
        <div className="experience-tabs">
          <button 
            className={`tab-button ${activeTab === 'teaching' ? 'active' : ''}`}
            onClick={() => setActiveTab('teaching')}
          >
            <span className="tab-icon">🎓</span>
            Teaching Experience
          </button>
          <button 
            className={`tab-button ${activeTab === 'administrative' ? 'active' : ''}`}
            onClick={() => setActiveTab('administrative')}
          >
            <span className="tab-icon">⚙️</span>
            Administrative Roles
          </button>
        </div>

        {/* Teaching Experience */}
        {activeTab === 'teaching' && (
          <div className="experience-content">
            <div className="timeline">
              {teachingExperience.map((exp, index) => (
                <div key={exp.id} className="timeline-item">
                  <div className="timeline-marker">
                    <div className="marker-circle"></div>
                    {index !== teachingExperience.length - 1 && <div className="timeline-line"></div>}
                  </div>
                  <div className="timeline-content">
                    <div className="experience-card">
                      <div className="card-header">
                        <div className="position-info">
                          <h3 className="position-title">{exp.position}</h3>
                          <span className="institution">{exp.institution}</span>
                        </div>
                        <div className="period-badge">
                          <span className="period">{exp.period}</span>
                          <span className="location">{exp.location}</span>
                        </div>
                      </div>
                      <div className="card-body">
                        <ul className="highlights-list">
                          {exp.highlights.map((highlight, idx) => (
                            <li key={idx} className="highlight-item">
                              <span className="bullet">•</span>
                              {highlight}
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Administrative Experience */}
        {activeTab === 'administrative' && (
          <div className="experience-content">
            <div className="admin-grid">
              {administrativeExperience.map((admin) => (
                <div key={admin.id} className="admin-card">
                  <div className="admin-header">
                    <h3 className="admin-role">{admin.role}</h3>
                    <span className="admin-institution">{admin.institution}</span>
                  </div>
                  <div className="admin-period">
                    {admin.period}
                  </div>
                  <div className="admin-body">
                    <h4 className="responsibilities-title">Key Responsibilities:</h4>
                    <ul className="responsibilities-list">
                      {admin.responsibilities.map((responsibility, idx) => (
                        <li key={idx} className="responsibility-item">
                          {responsibility}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Experience Summary */}
        <div className="experience-summary">
          <div className="summary-card">
            <div className="summary-item">
              <div className="summary-number">16+</div>
              <div className="summary-label">Years in Academia</div>
            </div>
            <div className="summary-item">
              <div className="summary-number">7+</div>
              <div className="summary-label">Institutions</div>
            </div>
            <div className="summary-item">
              <div className="summary-number">10+</div>
              <div className="summary-label">Leadership Roles</div>
            </div>
            <div className="summary-item">
              <div className="summary-number">1000+</div>
              <div className="summary-label">Students Mentored</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Experience;